
import { labelModule } from '@/store/modules/store-accessor'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class LabelExistsAlert extends Vue {

  @Prop({ required: true }) readonly labelType!: string;
  @Prop({ required: true }) readonly labelName!: string;
  @Prop() readonly exceptionId!: number;

  checkLabelExistenceValues = {label_type: this.labelType, name: this.labelName, exception_id: 0 };
  labelExists = false;
  debounceTimer: any = null;

  @Watch('labelName')
  onLabelNameChanged(newValue: string) {
    this.debouncedCheckDuplicates(newValue);
  }

debouncedCheckDuplicates(inputValue: string) {

  if (this.debounceTimer) {
    clearTimeout(this.debounceTimer);
  }

  const cleanInputValue = inputValue ? inputValue.replace(/ /g, '').replace(/-/g, '') : '';

  if (cleanInputValue.length === 0) {
    this.labelExists = false;
    this.$emit('label-exists', false);
    return;
  }

  this.debounceTimer = setTimeout(async () => {
    const payload: CheckLabelExistenceDto = {
        label_type: this.labelType,
        name: this.labelName,
    };

    if (this.exceptionId) {
        payload.exception_id = this.exceptionId;
    }

    this.labelExists = await labelModule.checkLabelExistence(payload);

    this.$emit('label-exists', this.labelExists);

  }, 800)
}

}
